import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import { GridFooterContainer, GridFooter } from "@mui/x-data-grid";

import dayjs from "dayjs";
import { useState, useEffect, useCallback } from "react";
import PdfGeneration from "../../../components/Utils/PdfGeneration";
import { updateRequisitionDates, updateTrackToggles } from "../../../components/Api/Updates";
import SummarizeIcon from "@mui/icons-material/Summarize";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ListSelect from "../../../components/Utils/ListSelect";
import { darken, lighten, styled } from "@mui/material/styles";
import { useMutation, useQueryClient } from "react-query";
import LinearProgress from "@mui/material/LinearProgress";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveIcon from "@mui/icons-material/Save";
import { useRequisitionQuery } from "../../../Hooks/useRequisitionQuery";
import isAuthenticated from "../../../components/Utils/isAuthenticated";
import { useTermsQuery } from "../../../Hooks/useTermsQuery";
import Snackbar from "@mui/material/Snackbar";
import TrackReqModal from "./TrackReqModal";
import CircularProgress from "@mui/material/CircularProgress";

const tssList = ["G", "J", "Mg", "Mt", "None"];
const getBackgroundColor = (color, mode) =>
	mode === "dark" ? darken(color, 0.7) : lighten(color, 0.7);
const getHoverBackgroundColor = (color, mode) =>
	mode === "dark" ? darken(color, 0.6) : lighten(color, 0.6);
const getSelectedBackgroundColor = (color, mode) =>
	mode === "dark" ? darken(color, 0.5) : lighten(color, 0.5);
const getSelectedHoverBackgroundColor = (color, mode) =>
	mode === "dark" ? darken(color, 0.4) : lighten(color, 0.4);
const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
	"& .super-app-theme--G": {
		backgroundColor: getBackgroundColor(theme.palette.george.main, theme.palette.mode),
		"&:hover": {
			backgroundColor: getHoverBackgroundColor(theme.palette.george.main, theme.palette.mode),
		},
		"&.Mui-selected": {
			backgroundColor: getSelectedBackgroundColor(theme.palette.george.main, theme.palette.mode),
			"&:hover": {
				backgroundColor: getSelectedHoverBackgroundColor(
					theme.palette.george.main,
					theme.palette.mode
				),
			},
		},
	},
	"& .super-app-theme--Mg": {
		backgroundColor: getBackgroundColor(theme.palette.success.main, theme.palette.mode),
		"&:hover": {
			backgroundColor: getHoverBackgroundColor(theme.palette.success.main, theme.palette.mode),
		},
		"&.Mui-selected": {
			backgroundColor: getSelectedBackgroundColor(theme.palette.success.main, theme.palette.mode),
			"&:hover": {
				backgroundColor: getSelectedHoverBackgroundColor(
					theme.palette.success.main,
					theme.palette.mode
				),
			},
		},
	},
	"& .super-app-theme--Mt": {
		backgroundColor: getBackgroundColor(theme.palette.mitra.main, theme.palette.mode),
		"&:hover": {
			backgroundColor: getHoverBackgroundColor(theme.palette.mitra.main, theme.palette.mode),
		},
		"&.Mui-selected": {
			backgroundColor: getSelectedBackgroundColor(theme.palette.mitra.main, theme.palette.mode),
			"&:hover": {
				backgroundColor: getSelectedHoverBackgroundColor(
					theme.palette.mitra.main,
					theme.palette.mode
				),
			},
		},
	},
	"& .super-app-theme--J": {
		backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
		"&:hover": {
			backgroundColor: getHoverBackgroundColor(theme.palette.info.main, theme.palette.mode),
		},
		"&.Mui-selected": {
			backgroundColor: getSelectedBackgroundColor(theme.palette.info.main, theme.palette.mode),
			"&:hover": {
				backgroundColor: getSelectedHoverBackgroundColor(
					theme.palette.info.main,
					theme.palette.mode
				),
			},
		},
	},
	"& .MuiDataGrid-overlay": {
		backgroundColor: "rgba(255, 255, 255, 0.7) !important",
	},
}));
export default function TrackRequisitionsTable(props) {
	//add column for notes
	let auth = isAuthenticated();
	const token = auth.token;
	const ccid = auth.ccid;
	const firstName = auth.firstName;
	const [requisitions, setRequisitions] = useState([]);
	const { data: termsList } = useTermsQuery(token);
	const [checkboxSelectionState, setCheckboxSelectionState] = useState({
		type: "include",
		ids: new Set(),
	});
	const [rows, setRows] = useState([]);
	const [changes, setChanges] = useState({});
	const [terms, setTerms] = useState([]);
	const queryClient = useQueryClient();
	const [termValue, setTermValue] = useState(0);
	const { data, isFetching, status } = useRequisitionQuery(token, ccid, termValue, {
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		enabled: !!termValue,
	});
	// const [filteredRowsLookup, setFilteredRowsLookup] = useState({});
	// const [numRows, setNumRows] = useState(0);
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [openTrackReqModal, setOpenTrackReqModal] = useState(false);

	const [loading, setLoading] = useState(false);
	const [initialRows, setInitialRows] = useState([]);
	const [filteredRows, setFilteredRows] = useState([]);
	const [activeFilter, setActiveFilter] = useState("none"); // 'none' | 'onlyMe' | 'incomplete'

	useEffect(() => {
		if (isFetching) {
			setLoading(true);
		} else {
			setLoading(false);
		}
	}, [isFetching]);

	let tsqsUser = "";

	if (firstName === "George") {
		tsqsUser = "G";
	} else if (firstName === "Mitra") {
		tsqsUser = "Mt";
	} else if (firstName === "Johnathan") {
		tsqsUser = "J";
	} else if (firstName === "Margarita") {
		tsqsUser = "Mg";
	}
	useEffect(() => {
		if (data && status === "success" && data.length > 0) {
			setRequisitions(data);
		} else if (data && status === "success" && data.length === 0) {
			setRequisitions([]);
			//set term to term - 10
			const previousTerm = termValue - 10;
			setTermValue(previousTerm);
		}
	}, [data, status, termValue]);

	useEffect(() => {
		if (termsList) {
			//get max term
			const maxTerm = Math.max(...termsList);
			setTermValue(maxTerm);
			const termList = [];
			termsList.forEach((term) => {
				termList.push(term);
			});
			setTerms(termList);
		}
	}, [termsList]);
	if (requisitions.length > 0 && token) {
		requisitions.forEach((requisition) => {
			if (requisition.requisitionModified === true) {
				const requisitionsCopy = [...requisitions];
				updateRequisitionDates(
					token,
					requisition.reqnum,
					dayjs(requisition.start_date).format("YYYY-MM-DD"),
					dayjs(requisition.end_date).format("YYYY-MM-DD")
				);
				requisitionsCopy.forEach((requisitionCopy) => {
					if (requisitionCopy.reqnum === requisition.reqnum) {
						requisitionCopy.requisitionModified = false;
					}
				});
				setRequisitions(requisitionsCopy);
			}
			requisition.classes.forEach((cls) => {
				requisition.term = cls.term;
			});
			requisition.start_date = dayjs(requisition.start_date).format("YYYY/MM/DD");
			requisition.end_date = dayjs(requisition.end_date).format("YYYY/MM/DD");
		});
	}
	const handlePrintAllSelected = () => {
		let multi = true;
		checkboxSelectionState?.ids.forEach((req) => {
			let selectedReq = requisitions.find((requisition) => {
				return requisition.reqnum === req;
			});
			printRow(selectedReq, multi);
		});
	};

	const handleMarkAllRepAssigned = () => {
		if (checkboxSelectionState?.type === "exclude" && checkboxSelectionState?.ids.size === 0) {
			// All are selected, so marking all
			rows.forEach((requisition, index) => {
				requisition.rep_assigned = tsqsUser;
				const date = dayjs().format("YYYY-MM-DD HH:mm:ss");
				requisition.rep_assigned_date = date;
				setChanges((prevChanges) => ({
					...prevChanges,
					[index]: {
						...prevChanges[index],
						rep_assigned: tsqsUser,
						reqnum: requisition.reqnum,
						rep_assigned_date: date,
					},
				}));
			});
		} else {
			checkboxSelectionState?.ids.forEach((req) => {
				let selectedReq = requisitions.find((requisition) => {
					return requisition.reqnum === req;
				});
				const rowIndex = rows.findIndex((r) => r.reqnum === req);
				selectedReq.rep_assigned = tsqsUser;
				const date = dayjs().format("YYYY-MM-DD HH:mm:ss");
				selectedReq.rep_assigned_date = date;
				setChanges((prevChanges) => ({
					...prevChanges,
					[rowIndex]: {
						...prevChanges[rowIndex],
						rep_assigned: tsqsUser,
						rep_assigned_date: date,
						reqnum: req,
					},
				}));
			});
		}
	};

	const handleToggleReport = () => {
		if (checkboxSelectionState?.type === "exclude" && checkboxSelectionState?.ids.size === 0) {
			// All are selected, so toggling all
			rows.forEach((requisition, index) => {
				requisition.report = !requisition.report;
				setChanges((prevChanges) => ({
					...prevChanges,
					[index]: {
						...prevChanges[index],
						report: requisition.report,
						reqnum: requisition.reqnum,
					},
				}));
			});
			return;
		} else {
			checkboxSelectionState?.ids.forEach((req) => {
				let selectedReq = requisitions.find((requisition) => {
					return Number(requisition.reqnum) === Number(req);
				});
				const rowIndex = rows.findIndex((r) => Number(r.reqnum) === Number(req));
				selectedReq.report = !selectedReq.report;
				setChanges((prevChanges) => ({
					...prevChanges,
					[rowIndex]: {
						...prevChanges[rowIndex],
						report: selectedReq.report,
						reqnum: req,
					},
				}));
			});
		}
	};

	const handleToggleContEmailed = () => {
		if (checkboxSelectionState?.type === "exclude" && checkboxSelectionState?.ids.size === 0) {
			// All are selected, so toggling all
			rows.forEach((requisition, index) => {
				requisition.cont_emailed = !requisition.cont_emailed;
				setChanges((prevChanges) => ({
					...prevChanges,
					[index]: {
						...prevChanges[index],
						cont_emailed: requisition.cont_emailed,
						reqnum: requisition.reqnum,
					},
				}));
			});
			return;
		} else {
			checkboxSelectionState?.ids.forEach((req) => {
				let selectedReq = requisitions.find((requisition) => {
					return requisition.reqnum === req;
				});
				const rowIndex = rows.findIndex((r) => r.reqnum === req);
				selectedReq.cont_emailed = !selectedReq.cont_emailed;
				setChanges((prevChanges) => ({
					...prevChanges,
					[rowIndex]: {
						...prevChanges[rowIndex],
						cont_emailed: selectedReq.cont_emailed,
						reqnum: req,
					},
				}));
			});
		}
	};

	useEffect(() => {
		const transformProperty = (requisition, property) => {
			requisition[property] = [undefined, null, false, "", "N"].includes(requisition[property])
				? false
				: true;
		};
		requisitions.forEach((requisition) => {
			transformProperty(requisition, "loaded");
			transformProperty(requisition, "report");
			transformProperty(requisition, "cont_emailed");
			transformProperty(requisition, "released");
			transformProperty(requisition, "inst_emailed");
			transformProperty(requisition, "tss_done");
			transformProperty(requisition, "tss_ia");
			transformProperty(requisition, "tss_sa");
		});
		setInitialRows([...requisitions]);
	}, [requisitions]);

	const applyActiveFilter = useCallback(
		(baseRows) => {
			if (!Array.isArray(baseRows)) return [];
			if (activeFilter === "onlyMe") {
				return baseRows.filter((row) => row.rep_assigned === tsqsUser);
			}
			if (activeFilter === "incomplete") {
				return baseRows.filter(
					(row) =>
						row.rep_assigned === tsqsUser && (row.report === false || row.cont_emailed === false)
				);
			}
			return baseRows;
		},
		[activeFilter, tsqsUser]
	);

	useEffect(() => {
		const nextFilteredRows = initialRows
			.filter((row) => row.term === termValue)
			.filter((row) => row.classes.some((cls) => cls.cls_rel === "Y"));
		setFilteredRows(nextFilteredRows);
		setRows(applyActiveFilter(nextFilteredRows));
	}, [termValue, initialRows, applyActiveFilter]);

	useEffect(() => {
		// Re-apply the active filter any time the base filtered rows change
		setRows(applyActiveFilter(filteredRows));
	}, [filteredRows, applyActiveFilter]);

	useEffect(() => {
		if (requisitions && requisitions.length > 0) {
			requisitions.forEach((requisition) => {
				const fullyReleased = requisition.classes.every(
					(cls) => cls.rel_date !== null && cls.rel_date !== ""
				);
				const partiallyReleased = requisition.classes.some(
					(cls) => cls.rel_date !== null && cls.rel_date !== ""
				);
				const notReleased = requisition.classes.every(
					(cls) => cls.rel_date === null || cls.rel_date === ""
				);
				if (fullyReleased) {
					requisition.grades_released_status = "full";
				}
				if (partiallyReleased) {
					let fakePartial = true;
					requisition.classes.forEach((cls) => {
						if ((cls.rel_date === null || cls.rel_date === "") && cls.qtally !== 0) {
							fakePartial = false;
						}
					});
					if (fakePartial) {
						requisition.grades_released_status = "full";
					} else {
						requisition.grades_released_status = "partial";
					}
				}
				if (notReleased) {
					requisition.grades_released_status = "none";
				}
			});
		}
	}, [requisitions]);
	const bulkUpdateMutation = useMutation(
		({ token, changes }) => updateTrackToggles({ token, changes }), // replace '/api/endpoint' with your API endpoint
		{
			onSuccess: () => {
				// Invalidate and refetch
				queryClient.invalidateQueries("requisitions");
			},
		}
	);
	const handleSave = async () => {
		await bulkUpdateMutation.mutateAsync({ token, changes });
		// After successful update, refresh rows from the server
		// and clear the changes
		/* fetchRows(); */
		setChanges({});
	};
	const createRenderToggle = (property, toggleHandler) => (params) => {
		const { row } = params;
		const rowIndex = rows.findIndex((r) => r.reqnum === row.reqnum);
		return (
			<strong>
				<Checkbox
					checked={row[property] || false}
					sx={{}}
					onChange={() => toggleHandler(rowIndex)}
					inputProps={{ "aria-label": "controlled" }}
				/>
			</strong>
		);
	};

	const handleDepartmentLongPress = useCallback(
		(department) => {
			// Find all reqnums with matching department
			const deptReqnums = rows.filter((row) => row.raddr2 === department).map((row) => row.reqnum);

			// Get current selection as array
			const currentSelection = Array.from(checkboxSelectionState?.ids || []);

			// Check if all dept requisitions are already selected
			const allSelected = deptReqnums.every((reqnum) => currentSelection.includes(reqnum));

			let newSelection;
			if (allSelected) {
				// Remove all dept requisitions from selection
				newSelection = currentSelection.filter((reqnum) => !deptReqnums.includes(reqnum));
			} else {
				// Add all dept requisitions to selection
				newSelection = [...new Set([...currentSelection, ...deptReqnums])];
			}

			setCheckboxSelectionState({ type: "include", ids: new Set(newSelection) });
		},
		[rows, checkboxSelectionState]
	);

	const renderDepartment = useCallback(
		(params) => {
			const { row } = params;
			const department = row.raddr2;

			const handleToggleAll = (e) => {
				e.stopPropagation();
				handleDepartmentLongPress(department);
			};

			return (
				<div className="flex items-center w-full h-full gap-1">
					<span className="truncate flex-1">{department}</span>
					<button
						type="button"
						onClick={handleToggleAll}
						className="bg-primary/60 hover:bg-primary/80 px-1.5 py-0.5 rounded text-white text-xs"
						title="Toggle all requisitions in this department"
					>
						All
					</button>
				</div>
			);
		},
		[handleDepartmentLongPress]
	);

	const createToggleHandler = (property) => (rowIndex) => {
		const updatedList = [...rows];
		const reqnum = updatedList[rowIndex].reqnum;
		updatedList[rowIndex][property] = !updatedList[rowIndex][property];
		setChanges((prevChanges) => ({
			...prevChanges,
			[rowIndex]: {
				...prevChanges[rowIndex],
				[property]: rows[rowIndex][property],
				reqnum: reqnum,
			},
		}));
	};

	const handleReportToggle = createToggleHandler("report");
	const handleContEmailedToggle = createToggleHandler("cont_emailed");

	const renderReportToggle = createRenderToggle("report", handleReportToggle);
	const renderContEmailedToggle = createRenderToggle("cont_emailed", handleContEmailedToggle);

	const renderReleasedToggle = (params) => {
		const { row } = params;
		if (row.grades_released_status === "full") {
			return (
				<strong>
					<CheckBoxIcon sx={{ color: "primary.main" }} />
				</strong>
			);
		} else if (row.grades_released_status === "partial") {
			return (
				<strong>
					<CheckBoxIcon sx={{ color: "yellow" }} />
				</strong>
			);
		} else if (row.grades_released_status === "none") {
			return (
				<strong>
					<CheckBoxOutlineBlankIcon sx={{ color: "greys.main" }} />
				</strong>
			);
		}
	};
	const renderHeader = (title, icon) => {
		return (
			<Box sx={{ mt: "10px", ml: "3px" }}>
				<Tooltip title={title} placement="top">
					{icon}
				</Tooltip>
			</Box>
		);
	};

	const renderReportHeader = () => {
		return renderHeader("Report Generated", <SummarizeIcon />);
	};
	const renderContEmailedHeader = () => {
		return renderHeader("Contact Emailed", <ContactMailIcon />);
	};
	const renderReleasedHeader = () => {
		return renderHeader("All Classes Released", <ChecklistIcon />);
	};
	const renderInstEmailedHeader = () => {
		return renderHeader("Instructor Email Scheduled", <ScheduleSendIcon />);
	};
	const handleChangeReportAssigned = (event, rowIndex) => {
		const updatedList = [...rows];
		if (event.target.value === "None") {
			updatedList[rowIndex].rep_assigned = null;
		} else {
			updatedList[rowIndex].rep_assigned = event.target.value;
		}
		const reqnum = updatedList[rowIndex].reqnum;
		setChanges((prevChanges) => ({
			...prevChanges,
			[rowIndex]: {
				...prevChanges[rowIndex],
				rep_assigned: rows[rowIndex].rep_assigned,
				reqnum: reqnum,
			},
		}));
	};
	const renderReportAssigned = (params) => {
		const { row } = params;
		const rowIndex = rows.findIndex((r) => r.reqnum === row.reqnum);
		return (
			<div className="flex flex-col items-center justify-center h-full ">
				<ListSelect
					list={tssList}
					width="70px"
					size="small"
					className="my-auto h-full"
					marginTop="20px"
					value={row.rep_assigned || ""}
					onChange={(event) => handleChangeReportAssigned(event, rowIndex)}
				/>
			</div>
		);
	};

	const printRow = (row, multi) => {
		PdfGeneration(row, multi);
	};
	const setStartDate = (params) => {
		const startDateFromRow = params.value;
		const updatedRows = [...requisitions];
		const index = updatedRows.findIndex((r) => r.reqnum === params.row.reqnum);
		updatedRows[index].start_date = dayjs(startDateFromRow);
		updatedRows[index].requisitionModified = true;
		setRequisitions(updatedRows);
		return {
			...params.row,
			start_date: dayjs(startDateFromRow).format("YYYY-MM-DD"),
		};
	};
	const setEndDate = (params) => {
		const endDateFromRow = params.value;
		const updatedRows = [...requisitions];
		const index = updatedRows.findIndex((r) => r.reqnum === params.row.reqnum);
		updatedRows[index].end_date = dayjs(endDateFromRow);
		updatedRows[index].requisitionModified = true;
		setRequisitions(updatedRows);
		return {
			...params.row,
			end_date: dayjs(endDateFromRow).format("YYYY-MM-DD"),
		};
	};
	const handleRefresh = () => {
		queryClient.invalidateQueries("requisitions");
	};

	const renderNumberClasses = (params) => {
		//if any class in params.row.classes has a cls_rel date that is after the params.row.date_assigned, return true
		const { row } = params;

		const numberOfClassesReleased = row.classes.filter((cls) => cls.cls_rel === "Y").length;

		return <span className="text-md font-semibold">{numberOfClassesReleased} </span>;
	};

	const filterOnlyMeRep = () => {
		setActiveFilter("onlyMe");
	};

	const filterNotDoneRep = () => {
		setActiveFilter("incomplete");
	};

	const clearCheckboxSelection = () => {
		setCheckboxSelectionState({ type: "include", ids: new Set() });
	};

	const clearFilters = () => {
		setActiveFilter("none");
	};

	const generateList = () => {
		let list = [];
		let nodupesList = [];

		// Iterate over the keys of checkboxSelectionState
		checkboxSelectionState?.ids.forEach((index) => {
			let selectedReq = requisitions.find((requisition) => {
				return requisition.reqnum === index;
			});
			if (selectedReq) {
				// Push the row data to the list
				list.push(selectedReq.reqnum);
			}
		});

		//remove dupes
		nodupesList = [...new Set(list)];
		const sortedList = nodupesList.sort((a, b) => a.reqnum - b.reqnum);
		//join into string
		list = sortedList.map((row) => JSON.stringify(row)).join(",");

		// Copy list to clipboard
		navigator.clipboard.writeText(list).then(
			function () {
				setSnackbarOpen(true);
			},
			function (err) {
				console.error("Could not copy text: ", err);
			}
		);

		return list;
	};
	const CustomFooter = () => {
		return (
			<GridFooterContainer sx={{ display: "flex", justifyContent: "flex-start", gap: 2 }}>
				<Button variant="outlined" sx={{ marginLeft: "5px" }} onClick={handlePrintAllSelected}>
					Download All Selected
				</Button>

				<GridFooter sx={{ position: "absolute", right: "10px" }} />
			</GridFooterContainer>
		);
	};

	const renderCountInstructorsEmailed = (params) => {
		const { row } = params;
		const numberOfInstructorsEmailed = row.classes.filter(
			(cls) => cls.rpdate !== null && cls.rpdate !== ""
		).length;
		const numberOfClasses = row.classes.length;
		return (
			<span className="text-md font-semibold">
				{numberOfInstructorsEmailed} / {numberOfClasses}
			</span>
		);
	};

	const columnsReports = [
		{
			field: "reqnum",
			headerName: "ReqNum",
			width: 70,
		},

		{
			field: "noCls",
			headerName: "#Cls",
			width: 60,
			align: "",
			renderCell: renderNumberClasses,
		},

		{
			field: "userid",
			headerName: "User",
			flex: 0.3,
			width: 120,
		},

		{
			field: "raddr2",
			flex: 0.7,
			headerName: "Department",
			width: 120,
			renderCell: renderDepartment,
		},

		{ field: "term", headerName: "Term", width: 55 },

		{
			field: "start_date",
			headerName: "Start Date",
			type: "date",
			width: 100,
			valueSetter: (params) => setStartDate(params),
			renderCell: (params) => {
				return dayjs(params.row?.start_date).format("DD-MMM-YYYY");
			},
			//as date type
			valueGetter: (params) => {
				return dayjs(params.row?.start_date).toDate();
			},
			editable: true,
		},

		{
			field: "end_date",
			headerName: "End Date",
			type: "date",
			width: 100,
			valueSetter: (params) => setEndDate(params),
			renderCell: (params) => {
				return dayjs(params.row?.end_date).format("DD-MMM-YYYY");
			},
			//as date type
			valueGetter: (params) => {
				return dayjs(params.row?.end_date).toDate();
			},
			editable: true,
		},

		{
			field: "rep_assigned",
			headerName: "Report",
			width: 80,
			align: "center",
			headerAlign: "center",
			renderCell: renderReportAssigned,
			sortComparator: (v1, v2, cellParams1, cellParams2) => {
				const order = ["None", "G", "J", "Mt", "Mg"];
				return order.indexOf(cellParams1.value) - order.indexOf(cellParams2.value);
			},
		},

		{
			field: "report",
			headerName: "",
			align: "center",
			width: 20,
			renderCell: renderReportToggle,
			renderHeader: renderReportHeader,
			sortable: false,
			filterable: false,
			disableColumnMenu: true,
		},

		{
			field: "cont_emailed",
			headerName: "",
			align: "center",
			width: 20,
			renderCell: renderContEmailedToggle,
			renderHeader: renderContEmailedHeader,
			sortable: false,
			filterable: false,
			disableColumnMenu: true,
		},

		{
			field: "grades_released_status",
			headerName: "",
			align: "center",
			width: 30,
			renderCell: renderReleasedToggle,
			renderHeader: renderReleasedHeader,
			disableColumnMenu: true,
			sortComparator: (v1, v2) => {
				if (v1 === "full" && v2 !== "full") {
					return -1;
				}
				if (v1 !== "full" && v2 === "full") {
					return 1;
				}
				if (v1 === "partial" && v2 === "none") {
					return -1;
				}
				if (v1 === "none" && v2 === "partial") {
					return 1;
				}
				return 0;
			},
		},

		{
			field: "inst_emailed",
			headerName: "",
			align: "center",
			width: 50,
			renderCell: renderCountInstructorsEmailed,
			renderHeader: renderInstEmailedHeader,
		},
	];

	const getRowClassName = useCallback((params) => {
		return `super-app-theme--${
			params.row.rep_assigned === "" || params.row.rep_assigned === null
				? params.row.req_assigned
				: params.row.rep_assigned
		}`;
	}, []);

	const handleSelectionModelChange = useCallback((newSelection) => {
		setCheckboxSelectionState(newSelection);
	}, []);

	const handleCloseSnackbar = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setSnackbarOpen(false);
	};

	return (
		<div className="flex h-full w-full bg-white shadow-sm">
			<Snackbar
				open={snackbarOpen}
				autoHideDuration={2000}
				onClose={handleCloseSnackbar}
				message="Copied to clipboard!"
			/>
			<TrackReqModal open={openTrackReqModal} setOpen={setOpenTrackReqModal} />
			<div className=" flex justify-center items-center w-full">
				<div className=" left-panel border-l border-t border-b rounded-l-md w-1/5 h-full flex flex-col">
					<Box className="h-[calc(4rem-4px)] w-full border-b flex justify-center items-center">
						<span className="text-lg"> Track Requisitions</span>
					</Box>
					<Box
						sx={{
							width: "100%",
							borderBottom: "1px solid #d1d1d1",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							gap: "8px",
							paddingY: "20px",
						}}
					>
						<Button
							color="greys"
							sx={{ width: "200px" }}
							variant="contained"
							onClick={filterOnlyMeRep}
						>
							Filter for "{tsqsUser}"
						</Button>

						<Button variant="contained" sx={{ width: "200px" }} onClick={generateList}>
							Get Reqnum String ({checkboxSelectionState?.ids?.size})
						</Button>
					</Box>

					<Box
						sx={{
							width: "100%",
							borderBottom: "1px solid #d1d1d1",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							gap: "8px",
							paddingY: "20px",
						}}
					>
						<Button
							variant="contained"
							sx={{ width: "200px" }}
							color="primary"
							onClick={handleMarkAllRepAssigned}
						>
							Assign {checkboxSelectionState?.ids?.size} to "{tsqsUser}"
						</Button>

						<Button variant="outlined" sx={{ width: "200px" }} onClick={handleToggleReport}>
							Toggle {checkboxSelectionState?.ids?.size} "Report Generated"
						</Button>
						<Button variant="outlined" sx={{ width: "200px" }} onClick={handleToggleContEmailed}>
							Toggle {checkboxSelectionState?.ids?.size} "Cont Emailed"
						</Button>

						<Button
							color="greys"
							variant="contained"
							sx={{ width: "200px" }}
							onClick={filterNotDoneRep}
						>
							Filter Incomplete
						</Button>
					</Box>

					<Box
						sx={{
							width: "100%",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							gap: "8px",
							paddingY: "20px",
						}}
					>
						<Button
							variant="contained"
							color="error"
							sx={{ width: "200px" }}
							onClick={clearCheckboxSelection}
						>
							Clear Checkbox Selection
						</Button>
						<Button
							variant="contained"
							color="error"
							sx={{ width: "200px" }}
							onClick={clearFilters}
						>
							Clear Filters
						</Button>
					</Box>
				</div>
				<div className="flex flex-col h-full  w-4/5 ">
					<div className="flex justify-between w-full items-center h-[calc(4rem+1px)] px-2 border-t border-r rounded-tr-md border-l">
						<div className="flex gap-2 ">
							<span className="self-center">Term:</span>
							<ListSelect
								className="termSelect"
								list={terms}
								width="100px"
								size="small"
								marginBottom="0px"
								value={termValue || ""}
								onChange={(event) => setTermValue(event.target.value)}
							/>
						</div>

						<div className="p-1">
							<Button variant="outlined" sx={{ marginLeft: "5px" }} onClick={handleRefresh}>
								REFRESH
								{loading ? (
									<CircularProgress size={20} sx={{ marginLeft: "9px" }} />
								) : (
									<RefreshIcon sx={{ marginLeft: "5px" }} />
								)}
							</Button>
							<Button variant="contained" sx={{ marginLeft: "5px" }} onClick={handleSave}>
								SAVE
								<SaveIcon sx={{ marginLeft: "5px" }} />
							</Button>
						</div>
					</div>
					<div className="h-full w-full">
						<StyledDataGrid
							loading={loading}
							sx={{
								"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
									outline: "None !important",
								},
								"& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
									width: "0.4em",
								},
								"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
									background: "#f1f1f1",
								},
								"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
									backgroundColor: "#888",
								},
								"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
									background: "#555",
								},

								borderRadius: "0px 4px 4px 0px",
							}}
							autoPageSize
							// disableRowSelectionOnClick
							checkboxSelection
							rowSelectionModel={checkboxSelectionState}
							getRowClassName={getRowClassName}
							onRowSelectionModelChange={handleSelectionModelChange}
							initialState={{
								sorting: {
									sortModel: [{ field: "start_date", sort: "asc" }],
								},
							}}
							slots={{
								footer: CustomFooter,

								LoadingOverlay: LinearProgress,
							}}
							rows={rows}
							density="compact"
							columns={columnsReports}
							getRowId={(row) => row.reqnum}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
